import { IQuote } from '@/interfaces';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { cloneDeep } from 'lodash-es';

export const useIQOriginalQuoteStore = defineStore('IQOriginalQuote', () => {
  const quote = ref<Partial<IQuote>>();

  /**
   * Will only set the quote once.
   */
  function setQuote(updateQuote: Partial<IQuote>, forceRefresh: boolean = false) {
    if (!quote.value || forceRefresh) {
      quote.value = cloneDeep(updateQuote);
    }
  }

  return {
    setQuote,
    quote,
  };
});
